export type UserStatusType = 'ONLINE' | 'OFFLINE';

export interface PresenceInfo {
  userStatus: UserStatusType;
  lastSeen: string;
}

export type UserPresenceMap = Record<string, PresenceInfo>;

export type UserPresenceStatus = Array<{ userId: string; userStatus: string; lastSeen: string; orgId: string }>;

export type UserPresenceResponse = {
  orgUserPresence: UserPresenceStatus;
};
export interface UserPresenceState {
  userPresenceData: UserPresenceMap;
  loading: boolean;
  setUserPresenceData: (list: UserPresenceStatus) => void;
  updateUserPresence: (userId: string, userStatus: UserStatusType, lastSeen: string) => void;
  setLoading: (loading: boolean) => void;
}

export const StatusTypes = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
};

export interface OrgUserPresenceEvent {
  method: 'ORG_USER_PRESENCE';
  id: string;
  params: {
    user_id: string;
    user_status: number;
    org_id: string;
    last_seen: {
      seconds: number;
      nanos: number;
    };
  };
}
